// Customer-facing phone numbers. Kept in one place rather than hard-coded across components.
export const SALES_PHONE = "020 8492 6868";
export const SUPPORT_PHONE = "020 8492 6828";
